(function () {
  if (window.__backOrderInit) return;
  window.__backOrderInit = true;

  var BACK_ORDER_LABEL = 'Back Order';
  var OUT_OF_STOCK_LABEL = 'Out of stock';

  function getAddToCartLabel() {
    if (
      window.theme &&
      window.theme.variantStrings &&
      window.theme.variantStrings.addToCart
    ) {
      return window.theme.variantStrings.addToCart;
    }
    return 'Add to Cart';
  }

  function loadFlags() {
    var map = {};
    document
      .querySelectorAll('script[type="application/json"][data-back-order-flags]')
      .forEach(function (el) {
        try {
          var data = JSON.parse(el.textContent) || {};
          Object.keys(data).forEach(function (k) {
            var v = data[k];
            if (typeof v === 'boolean') {
              // Legacy format: plain back-order boolean.
              map[String(k)] = { available: true, backOrder: v };
            } else if (v && typeof v === 'object') {
              map[String(k)] = {
                available: v.available !== false,
                backOrder: v.backOrder === true,
              };
            }
          });
        } catch (e) {}
      });
    return map;
  }

  var flags = {};
  var currentMainVariantId = null;

  function getMainVariantId() {
    if (currentMainVariantId != null) return currentMainVariantId;
    var input = document.querySelector('.Bundle1_product_form input[name="id"]');
    return input ? input.value : null;
  }

  // Double-SKU desks: frame/legs inventory is tracked on the DISPLAY frame
  // product (custom.table_frame — the products with pictures), not on the
  // picture-less double-SKU cart components. The customizer swatch handlers
  // write the selected swatch's display variant id into this hidden input
  // (SSR sets the initial value in btx-main-product.liquid).
  function getComponentVariantIds() {
    var input = document.getElementById('frame_display_variant_input');
    if (input && input.value) return [input.value];
    return [];
  }

  // 'oos'       any selected component cannot be ordered at all
  // 'backorder' everything orderable, but a component is on back order
  // 'default'   everything in stock
  function computeState() {
    var ids = [getMainVariantId()].concat(getComponentVariantIds());
    var state = 'default';
    for (var i = 0; i < ids.length; i++) {
      var flag = ids[i] == null ? null : flags[String(ids[i])];
      if (!flag) continue;
      if (!flag.available) return 'oos';
      if (flag.backOrder) state = 'backorder';
    }
    return state;
  }

  var STOCK_STATUS_BY_STATE = {
    default: 'in-stock',
    backorder: 'back-order',
    oos: 'sold-out',
  };

  function applyStockStatus(state) {
    document.querySelectorAll('[data-stock-status]').forEach(function (el) {
      el.setAttribute('data-state', STOCK_STATUS_BY_STATE[state]);
    });
  }

  function applyState() {
    var state = computeState();
    applyStockStatus(state);
    var label =
      state === 'oos'
        ? OUT_OF_STOCK_LABEL
        : state === 'backorder'
          ? BACK_ORDER_LABEL
          : getAddToCartLabel();

    document.querySelectorAll('[data-back-order-button]').forEach(function (btn) {
      var labelEl = btn.querySelector('[data-back-order-label]');
      // A missing label span means other theme JS (e.g. the customizer's
      // all-frames-sold-out lock) replaced the button content — leave it alone.
      if (!labelEl) return;
      labelEl.textContent = label;
      btn.classList.toggle('is-preorder', state === 'backorder');
      if (state === 'oos') {
        btn.classList.add('is-oos');
        btn.setAttribute('disabled', 'disabled');
      } else if (btn.classList.contains('is-oos')) {
        // Only clear a disabled state this module set itself.
        btn.classList.remove('is-oos');
        btn.removeAttribute('disabled');
      }
    });
    document.querySelectorAll('[data-back-order-badge]').forEach(function (el) {
      if (state === 'backorder') el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function handleVariantEvent(event) {
    var detail = event && event.detail;
    var variant = detail && (detail.variant || detail.resource);
    if (!variant || variant.id == null) return;
    // Defer to product.js / native form behavior when the variant is sold out.
    if (variant.available === false) {
      applyStockStatus('oos');
      return;
    }
    currentMainVariantId = variant.id;
    applyState();
  }

  function handleRefresh() {
    applyState();
  }

  function init() {
    flags = loadFlags();
    document.addEventListener('product:variant-change', handleVariantEvent);
    document.addEventListener('variant:update', handleVariantEvent);
    // Dispatched by the customizer frame-swatch handlers after they rewrite
    // the component hidden inputs (no variant payload — state is re-read
    // from the inputs).
    document.addEventListener('back-order:refresh', handleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
